import * as React from 'react'
import IconButton from "./IconButton";
import { useHistory } from 'react-router-dom';

interface IProps {
  onClick?: () => void
}

const BackButton = (props: IProps) => {
  const history = useHistory()

  const onClick = () => {
    history.goBack()

    if (props?.onClick) props.onClick()
  }

  return (
    <IconButton onClick={onClick}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.85 3.99984C10.85 4.21984 10.77 4.43984 10.6 4.59984L7.20005 7.99984L10.6 11.3998C10.93 11.7298 10.93 12.2698 10.6 12.5998C10.27 12.9298 9.73005 12.9298 9.40005 12.5998L4.80005 7.99984L9.40005 3.39984C9.73005 3.06984 10.27 3.06984 10.6 3.39984C10.77 3.56984 10.85 3.77984 10.85 3.99984Z" fill="currentColor"></path></svg>
    </IconButton>
  )
}

export default BackButton